import { render, staticRenderFns } from "./DataDangerModel.vue?vue&type=template&id=25aad014&scoped=true"
import script from "./DataDangerModel.vue?vue&type=script&lang=js"
export * from "./DataDangerModel.vue?vue&type=script&lang=js"
import style0 from "./DataDangerModel.vue?vue&type=style&index=0&id=25aad014&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aad014",
  null
  
)

export default component.exports